import { atom } from "recoil";

const photoSixState =atom({
    key: 'photoSix',
    default: false
})

export default photoSixState